module.exports = __webpack_public_path__ + "media/images/ceremony/top/plan/plan3-042b8de520ae004c0b4a3bdc35719af2.jpg";